import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {AdminAppRouting} from "./admin-app-routing.module";
import {AdminAppComponent} from "./admin-app.component";
import {HomeComponent} from "./+home/home.component";
import {NewsComponent} from "./+news/news.component";
import {NewsService} from "./shared/news.service";
import {UserService} from "./shared/user.service";
import {UsersComponent} from "./+users/users.component";
import {AboutComponent} from "./+about/about.component";

@NgModule({
  imports: [
    SharedModule,
    AdminAppRouting
  ],
  declarations: [
    AdminAppComponent,
    HomeComponent,
    NewsComponent,
    UsersComponent,
    AboutComponent
  ],
  providers: [
    NewsService,
    UserService
  ]
})
export class AdminAppModule {

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/+admin-app/admin-app.module.ts